import {Lazy} from './lazy';

export function lazyRnd(source: Lazy<number>): Lazy<number> {
  return () => {
    return +(source().toFixed(2));
  };
}

export function rnd(source: number, nrOfDecimals:number = 2): number {
  return +(source.toFixed(nrOfDecimals));
}
